import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-info-definition",
  templateUrl: "./info-definition.component.html",
  styleUrls: ["./info-definition.component.scss"],
})
export class InfoDefinitionComponent implements OnInit {
  pdfSrc = `${environment.hostURL}assets/pdf/Infographic.pdf`;
  ngOnInit(): void {
    try {
      const link = document.querySelector(".language-selector a") as HTMLAnchorElement;
      if (link) {
        link.href = `${window.location}#`;
      }
    } catch (error) {
      console.log(error);
    }
  }
}
